<template>
  <div class="coverageDetails-modal-backdrop" @click='close'>
    <div v-on:click.stop='stopClose()' class="coverageDetails-modal" role='dialog' aria-modal="true" :aria-label="$t('text.definition')">
      <header class="coverageDetails-modal-header">
        <slot name="header">
          <button
            id='btnCDClose'
            type="button"
            class="btn-close"
            @click="close"
            :aria-label="$t('text.close')"
          >
          X
          </button>
        </slot>
      </header>
      <section class="coverageDetails-modal-body">
        <div class='row' style='border-bottom: 1px solid #ccc;padding-bottom:5px;'>
          <div class='col-12 col-sm order-2 order-sm-1'>
            <div class='col-12 d-sm-none' style='height:25px;'></div>
            <h1 style='font-weight:bold;font-size:26px;' tabindex='-1'><slot name="title"></slot></h1>
            <div v-if='this.$store.state.site==="cibc"' class="col-12" style='padding-left:0px;'>{{$t('text.disclaimer')}}</div>
            <div v-else class="col-12" style='padding-left:0px;'>{{$t('text.disclaimernm')}}</div>
            <slot name="productcode">
            </slot>
          </div>
          <div class='col-12 order-1 order-sm-2 col-sm-auto'>
            <center>
              <button v-if='this.$route.meta.page === 8' id='btnCDSelect' @click="changeStep($event,'next')" class='btn btn-select' style='width:150px; margin-bottom:5px;'>{{$t('text.select')}}</button>
              <button v-else id='btnCDChangePlan' class='btn btn-select form-control' style='width:150px; margin-bottom:5px;' @click='changePlan()'>{{$t('text.changeplan')}}</button><br/>
              <button v-if='this.$store.state.site==="cibc"' @click='openPDFInNewWindow()' id='btnCDViewCertificate' class='btn btnHelp'>{{$t('text.footer_link4')}}</button>
              <button v-else @click='openPDFInNewWindow()' id='btnCDViewCertificate' class='btn btnHelp'>{{$t('text.footer_link4nm')}}</button>
              <!---<button @click='showModal()' class='btnHelp form-control'>{{$t('text.btn_needhelp')}}</button>-->
            </center>
          </div>
          <div class='col-12 order-3 d-sm-none' style='height:25px;'></div>
        </div>
        <div>
          <br/><br/>
          <h2 style='font-weight:bold; font-size:26px;'>{{$t('text.assistance')}}</h2>
          <p id='cd_coverage'>{{$t('text.coverage')}}</p>
        </div>
        <br/><br/>
        <div class='row text-center'>
          <div class='col-12 col-sm' id='cd_medical'  style='min-width: 215px'>
            <img src='../assets/images/medical.png'/>
            <h2 style='font-weight:bold;font-size:20px;margin-bottom:30px; height:50px;'>{{$t('text.medicalheader')}}</h2>
            <div class='row no-gutters'>
              <div class='col-auto' style='padding-right:10px;'><b>></b></div>
              <div class='col'>
                <p class='text-left' v-html='$t("text.medical1")'></p>
              </div>
            </div>
            <div class='row no-gutters'>
              <div class='col-auto' style='padding-right:10px;'><b>></b></div>
              <div class='col'>
                <p class='text-left' v-html='$t("text.medical2")'></p>
              </div>                
            </div>
            <div class='row no-gutters'>
              <div class='col-auto' style='padding-right:10px;'><b>></b></div>
              <div class='col'>
                <p class='text-left' v-html='$t("text.medical3")'></p>
              </div>                
            </div>
            <div class='row no-gutters'>
              <div class='col-auto' style='padding-right:10px;'><b>></b></div>
              <div class='col'>
                <p class='text-left' v-html='$t("text.medical4")'></p>
              </div>                
            </div>
          </div>
          <div class='col-12 col-sm' id='cd_tripcancel'  style='min-width: 215px'>
            <img src='../assets/images/tripcancel.png'/>
            <h2 style='font-weight:bold;font-size:20px;margin-bottom:30px; height:50px;'>{{$t('text.tripcancelheader')}}</h2>
            <div class='row no-gutters' id='tripcancel1'>
              <div class='col-auto' style='padding-right:10px;'><b>></b></div>
              <div class='col'>
                <p class='text-left' v-html='$t("text.tripcancel1")'></p>
              </div>
            </div>
            <div class='row no-gutters' id='tripcancel2'>
              <div class='col-auto' style='padding-right:10px;'><b>></b></div>
              <div class='col'>
                <p class='text-left' v-html='$t("text.tripcancel2")'></p>
              </div>                
            </div>
            <div class='row no-gutters' id='tripcancel3'>
              <div class='col-auto' style='padding-right:10px;'><b>></b></div>
              <div class='col'>
                <p class='text-left' v-html='$t("text.tripcancel3")'></p>
              </div>                
            </div>
          </div>
          <div class='col-12 col-sm' id='cd_transportation' style='min-width: 215px'>
            <img src='../assets/images/transportation.png'/>
            <h2 style='font-weight:bold;font-size:20px;margin-bottom:30px; height:50px;'>{{$t("text.transportationheader")}}</h2>
            <div class='row no-gutters' id='transportation1'>
              <div class='col-auto' style='padding-right:10px;'><b>></b></div>
              <div class='col'>
                <p class='text-left' v-html='$t("text.transportation1")'></p>
              </div>                
            </div>
            <div class='row no-gutters' id='transportation2'>
              <div class='col-auto' style='padding-right:10px;'><b>></b></div>
              <div class='col'>
                <p class='text-left' v-html='$t("text.transportation2")'></p>
              </div>                
            </div>
            <div class='row no-gutters' id='transportation3'>
              <div class='col-auto' style='padding-right:10px;'><b>></b></div>
              <div class='col'>
                <p class='text-left' v-html='$t("text.transportation3")'></p>
              </div>                
            </div>
            <div class='row no-gutters' id='transportation4'>
              <div class='col-auto' style='padding-right:10px;'><b>></b></div>
              <div class='col'>
                <p class='text-left' v-html='$t("text.transportation4")'></p>
              </div>                
            </div>
          </div>
          <div class='col-12 col-sm' id='cd_convenience'  style='min-width: 215px'>
            <img src='../assets/images/comfort.png'/>
            <h2 style='font-weight:bold;font-size:20px;margin-bottom:30px; height:50px;'>{{$t("text.convenienceheader")}}</h2>
            <div class='row no-gutters' id='convenience1'>
              <div class='col-auto' style='padding-right:10px;'><b>></b></div>
              <div class='col'>
                <p class='text-left' v-html='$t("text.convenience1")'></p>
              </div>                
            </div>
            <div class='row no-gutters' id='convenience2'>
              <div class='col-auto' style='padding-right:10px;'><b>></b></div>
              <div class='col'>
                <p class='text-left' v-html='$t("text.convenience2")'></p>
              </div>                
            </div>
            <div class='row no-gutters' id='convenience3'>
              <div class='col-auto' style='padding-right:10px;'><b>></b></div>
              <div class='col'>
                <p class='text-left' v-html='$t("text.convenience3")'></p>
              </div>                
            </div>
            <div class='row no-gutters' id='convenience4'>
              <div class='col-auto' style='padding-right:10px;'><b>></b></div>
              <div class='col'>
                <p class='text-left' v-html='$t("text.convenience4")'></p>
              </div>                
            </div>
            <div class='row no-gutters' id='convenience5'>
              <div class='col-auto' style='padding-right:10px;'><b>></b></div>
              <div class='col'>
                <p class='text-left' v-html='$t("text.convenience5")'></p>
              </div>                
            </div>
          </div>
        </div>
       </section>
    </div>
  </div>
</template>

<script>
import getLocale from "../utils/getLocale";
import bus from "../utils/bus.js";

export default {
  name: "coverageDetailsModal",
  computed: {
    urlPDF() {

    }
  },
  methods: {
    changeStep(event, targetStep) {
      let doValidation;
      if (targetStep === "next") {
        targetStep = this.$route.meta.nextStep;
        doValidation=true;
      } else {
        targetStep = this.$route.meta.previousStep;
        doValidation=false;
      }
      for(const category in this.$store.state.products){
        for(const product of this.$store.state.products[category].Products){
          if(event.target.getAttribute("data-product")===product.Product.ProductCode){
            this.$store.commit("setProduct", product);
          }
        }
      }
      
      this.close();
      this.$nextTick(()=>{
        bus.$emit("changeStep", this.$route.path, targetStep, doValidation);
      });
    },
    changePlan(){
      this.close();
      this.$router.push("/Quote");
    },
    stopClose(){
    },
    close() {
      document.getElementsByTagName("body")[0].classList.remove("modal-open");
      this.$emit("close");
    },
    openPDFInNewWindow(width, height) {
      let clientCode;
      if(this.$store.state.site==="cibc") {
        clientCode="CIBC"
      } else {
        clientCode="CIBCIndividual";
      }
      
      const targetURL = window.location.origin + "/" + getLocale(true)+"/api/certificate/"+clientCode+"/"+ document.getElementById("coverageDetailsProductCode").innerHTML;

      const popupWidth = width == null ? 500 : width;
      const popupHeight = height == null ? 600 : height;
      const newWindow = window.open(
        targetURL,
        "popup",
        "scrollbars=1,resizable=1,width=" +
          popupWidth +
          ",height=" +
          popupHeight
      );
    }
  }
};
</script>

<style>
  .coverageDetails-modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index:3;
  }

  .coverageDetails-modal {
    border-radius: 5px;
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    margin-top:40px;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
    width: 90%;
  }

  .coverageDetails-modal-header {
    text-align:right;
  }

  .coverageDetails-modal-header {
    color: #4AAE9B;
    justify-content: space-between;
  }

  .coverageDetails-modal-footer {
    border-top: 1px solid #eeeeee;
    justify-content: flex-end;
  }

  .coverageDetails-modal-body {
    position: relative;
    padding-bottom: 40px;
    padding-left: 50px;
    padding-right: 50px;
  }

  .coverageDetails-modal-body .row.no-gutters {
    flex-wrap: nowrap;
    align-items: flex-start;
  }

  .coverageDetails-modal-body .row.no-gutters > .col {
    min-width: 0;
  }
</style>